import { Edit, translate } from "react-admin";
import React from "react";

import GroupForm from "./GroupForm";

const GroupTitle = ({ translate, record }) => {
  return (
    <span>
      {`${translate("group.group")}`} {record ? `"${record.name}"` : ""}
    </span>
  );
};

const Title = translate(GroupTitle);

export const GroupEdit = props => (
  <Edit title={<Title />} {...props}>
    <GroupForm />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/components/group/GroupEdit.js